import React from "react";
import Icons from "../../../../Config/Images";
import Header from "../../Layout/Header/Header";
import Footer from "../../Layout/Footer/Footer";

const LiveRateComponent = () => {
  return (
    <div className="live-rate-main-div">
      <Header />
      <div >
        <img
          style={{ width: "100%"}}
          src={Icons.live_rating_image}
          alt=""
        />
      </div>
      <Footer />
    </div>
  );
};

export default LiveRateComponent;
